import classNames from "classnames";
import { ShowSidePanel } from "components/SidePanel/Show/ShowSidePanel";
import moment from "moment";
import React from "react";
import { formatWrittenDayMonthYearShort } from "utilities";
import { getCityStateCountry } from "shared/utils/addressUtils";

interface ShowForMapProps {
  selected: boolean
  hovered: boolean
  show: server.dto.ShowForPlanningMap
  onOpen: () => void
  onHover: (show: server.dto.ShowForPlanningMap) => void
}

const appointmentPhaseMap = serverReference.appointmentPhases.reduce((acc, phase) => {
  acc[phase.value] = phase;
  return acc;
}, {});

export const ShowForMap = ({ selected, hovered, show, onOpen, onHover }: ShowForMapProps) => {
  const classes = classNames("hoverable gray-100 planning-map-show-item-content", {
    "planning-map-item-content-selected": selected,
    "planning-map-item-content-hovered": hovered && !selected,
  });

  return <ShowSidePanel
    canEdit
    onOpen={onOpen}
    showId={show.showId}
    trigger={<div className={classes}
      onMouseEnter={() => onHover(show)}
      onMouseLeave={() => onHover(undefined)}>
      <div className="grow1">
        <div className="margin-bottom">
          <div className="text-ellipsis subtitle-text-medium">{show.eventName ?? "…"}&nbsp;|&nbsp;{show.venue.name}</div>
          <div className="text-ellipsis body-text-regular">{formatWrittenDayMonthYearShort(moment.utc(show.date))}</div>
          <div className="text-ellipsis body-text-regular s1_gray">{getCityStateCountry(show.venue.address)}</div>
        </div>
        <div>
          {show.artist && <div className="text-ellipsis subtitle-text-regular">{show.artist.name}</div>}
          {show.productionName && <div className="text-ellipsis body-text-regular s1_gray">{show.productionName}</div>}
        </div>
      </div>
      <i className={classNames("icon", appointmentPhaseMap[show.phase].icon)} />
    </div>}
  />
};
